import { graphql } from "gatsby";
import React, { Fragment, useEffect } from "react";
import { Helmet } from "react-helmet";
const RedirectPage = (props: any) => {
  return (
    <div>
      <Helmet>
        <html lang="en" />
        <meta
          http-equiv="refresh"
          content="0;URL='http://viz.fredhutch.org/'"
        />
      </Helmet>
      Redirecting to viz.fredhutch.org
    </div>
  );
};

export default RedirectPage;

export const pageQuery = graphql`
  query RedirectPage($id: String) {
    page: markdownRemark(id: { eq: $id }) {
      frontmatter {
        target
      }
    }
  }
`;
